export default {
  // ADD DEBIT CARD GENERAL
  "add-debit-card_page-title": "Request a Card",
  "add-debit-card_page-description": "Request a card page description",
  "___add-debit-card_action_done": "",
  "___add-debit-card_title_confirm-close": "",
  "___add-debit-card_text_confirm-close": "",
  "___add-debit-card_action_confirm-close_cancel": "",
  "___add-debit-card_action_confirm-close_confirm": "",
  "add-debit-card_form-option_myself": "Myself",
  "add-debit-card_form-option_dependent": "Another Dependent",
  "add-debit-card_action_submit": "Get Debit Card",
  "add-debit-card_text_submit-description": "The debit card will be mailed to the member address on file.",
  "add-debit-card_text_loading-message": "Requesting Debit Card…",
  "add-debit-card_text_success-message": "Curabitur blandit tempus porttitor.",
  "___add-debit-card_text_error-message_default": "",
  "add-debit-card_label_myself": "Myself",
  "___add-debit-card_label_spouse": "",
  "___add-debit-card_label_child": "",
  "add-debit-card_label_new-cardholder": "Add New Cardholder",
  "add-debit-card_text_duplicate-dependent": "Duplicant dependent",
  "add-debit-card_text_possible-duplicate-dependent": "Possible duplicate dependent – Do you want to continue?",
  "___add-debit-card_action_no": "",
  "___add-debit-card_action_yes": "",
  "add-debit-card_text_refresh-data-error-message": "Your debit card has been added but we were unable to refresh the data on the screen. Please refresh the page.",

  // Form labels
  "add-debit-card_form-label_request-card-for": "Request Card For",
  "add-debit-card_form-label_accounts-covered": "Accounts Covered",
  "add-debit-card_form-label_dependent-name": "Dependent Name",
  "___add-debit-card_form-label_first-name": "",
  "___add-debit-card_form-label_last-name": "",
  "add-debit-card_form-label_relationship": "Relationship",
  "___add-debit-card_form-label_dob": "",
  "___add-debit-card_form-label_terms-and-conditions": "",
  "___add-debit-card_form-label_terms-and-conditions-crossover": "",

  // Form errors
  "___add-debit-card_form-error_request-card-for_required": "",
  "add-debit-card_form-error_dependent-name_required": "Select a dependent",
  "add-debit-card_form-error_relationship_required": "Select the dependent’s relationship",
  "add-debit-card_form-error_first-name_required": "Enter the dependent’s first name",
  "add-debit-card_form-error_first-name_maxlength": "First name cannot be more than %maxLength% characters",
  "add-debit-card_form-error_last-name_required": "Enter the dependent’s last name",
  "add-debit-card_form-error_last-name_maxlength": "Last name cannot be more than %maxLength% characters",
  "add-debit-card_form-error_dob_required": "Select the dependent’s date of birth",
  "add-debit-card_form-error_dob_invalid-format": "Invalid Birth Date",
  "add-debit-card_form-error_dob_invalid-dob": "Date of birth must be in the past",
  "___add-debit-card_form-error_accounts-covered_required": "",
  "___add-debit-card_form-error_terms-and-conditions_required": "",
  "add-debit-card_form-label_terms-and-conditions": "I certify that such expenses will not be eligible for benefit pay by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transactions using funds other than HSA may be subjected to proof of purchase documentation upon request by SelectAccount. Failure to respond will result in cancellation of the debit card and I must reimburse them with after-tax dollars.",
  "add-debit-card_form-label_terms-and-conditions-crossover": "I certify that such expenses will not be eligible for benefit pay by any other insurance carrier and that such expenses will not be manually submitted by me to this or any other reimbursement account when I use my debit card. I understand that any debit card transactions using funds other than HSA may be subjected to proof of purchase documentation upon request by SelectAccount. Failure to respond will result in cancellation of the debit card and I must reimburse them with after-tax dollars. [Extra Crossover info here.]",

  // ADD SELF CARD
  "___add-self-debit-card_page-title": "",
  "add-self-debit-card_page-description": "Please read and confirm the information below.",
  "___add-self-debit-card_action_done": "",
  "___add-self-debit-card_action_submit": "",
  "___add-self-debit-card_title_confirm-close": "",
  "___add-self-debit-card_text_confirm-close": "",
  "___add-self-debit-card_action_confirm-close_cancel": "",
  "___add-self-debit-card_action_confirm-close_confirm": "",
  "___add-self-debit-card_text_submit-description": "",
  "___add-self-debit-card_text_loading-message": "",
  "___add-self-debit-card_text_success-message": "",
  "___add-self-debit-card_text_error-message_default": "",
  "___add-self-debit-card_form-label_terms-and-conditions": "",
  "___add-self-debit-card_form-label_terms-and-conditions-crossover": "",
  "___add-self-debit-card_form-error_terms-and-conditions_required": "",

  // ADD DEPENDENT CARD
  "___add-dependent-debit-card_page-title": "",
  "add-dependent-debit-card_page-description": "Please tell us who this card is for and confirm the information below.",
  "___add-dependent-debit-card_label_spouse": "",
  "___add-dependent-debit-card_label_child": "",
  "add-dependent-debit-card_label_new-dependent": "New Dependent",
  "___add-dependent-debit-card_action_done": "",
  "___add-dependent-debit-card_action_submit": "",
  "___add-dependent-debit-card_title_confirm-close": "",
  "___add-dependent-debit-card_text_confirm-close": "",
  "___add-dependent-debit-card_action_confirm-close_cancel": "",
  "___add-dependent-debit-card_action_confirm-close_confirm": "",
  "___add-dependent-debit-card_text_submit-description": "",
  "___add-dependent-debit-card_text_loading-message": "",
  "___add-dependent-debit-card_text_success-message": "",
  "___add-dependent-debit-card_text_error-message_default": "",
  "add-dependent-debit-card_form-label_dependent-name": "Dependent Name",
  "___add-dependent-debit-card_form-label_first-name": "",
  "___add-dependent-debit-card_form-label_last-name": "",
  "add-dependent-debit-card_form-label_dependent-type": "Dependent Type",
  "___add-dependent-debit-card_form-label_dob": "",
  "___add-dependent-debit-card_form-label_terms-and-conditions": "",
  "___add-dependent-debit-card_form-label_terms-and-conditions-crossover": "",
  "add-dependent-debit-card_form-error_dependent-name_required": "Select a dependent",
  // "add-dependent-debit-card_form-error_first-name_required": "Enter the dependent’s first name",
  // "add-dependent-debit-card_form-error_first-name_maxlength": "First name cannot be more than %maxLength% characters",
  // "add-dependent-debit-card_form-error_last-name_required": "Enter the dependent’s last name",
  // "add-dependent-debit-card_form-error_last-name_maxlength": "Last name cannot be more than %maxLength% characters",
  // "add-dependent-debit-card_form-error_dependent-type_required": "Select the dependent’s relationship",
  "add-dependent-debit-card_form-error_dob_required": "Select the dependent’s date of birth",
  "add-dependent-debit-card_form-error_dob_invalid-format": "Invalid Birth Date",
  "add-dependent-debit-card_form-error_dob_invalid-dob": "Date of birth must be in the past",
  "___add-dependent-debit-card_form-error_terms-and-conditions_required": "",
  "___add-dependent-debit-card_form-hint_dob": "",
};